/**
 * Step navigation and focus management
 */

import { getLocaleDateFormat } from '../utils/dateHelpers.js';

const INPUT_SELECTORS = {
    1: '#email',
    2: '#name',
    3: null, // Birthday - determined dynamically based on date format
    4: null, // Sex - no focus needed (buttons)
    5: '#suCityName',
    6: '#suHomeCityName',
    7: '#password',
    8: '#username'
};

/**
 * Get the selector for the first birthday field based on locale date format.
 * MDY format: Month is first
 * DMY format: Day is first
 * YMD format: Year is first
 */
function getBirthdayFirstFieldSelector() {
    const format = getLocaleDateFormat();
    switch (format) {
        case 'MDY':
            return 'select[name="month"]';
        case 'YMD':
            return 'select[name="year"]';
        default: // DMY
            return 'select[name="day"]';
    }
}

export function focusCurrentInput(step) {
    let selector = INPUT_SELECTORS[step];

    // For birthday step, determine first field based on date format
    if (step === 3) {
        selector = getBirthdayFirstFieldSelector();
    }

    if (selector) {
        const input = document.querySelector(selector);
        if (input) {
            // Focus immediately to maintain user gesture chain for mobile keyboard
            input.focus();

            // On mobile, also trigger click to ensure keyboard appears
            if ('ontouchstart' in window) {
                input.click();
            }
        }
    }
}

export function isCityStep(step) {
    return step === 5 || step === 6;
}

export function getCityInputId(step) {
    return step === 5 ? 'suCityName' : 'suHomeCityName';
}
